export { ModalTotalFooter } from './ModalTotalFooter';
export type { ModalTotalFooterProps } from './ModalTotalFooter.types';
